module.exports = {"title":"Manage coupons","couponName":"Coupon name","redemptionCount":"Redemption Count","status":"Status","active":"Active","inactive":"Inactive","addNewCoupon":"Add new coupon","msg":{"yay":"Yay!","oops":"Oops!","success":"Coupon have been deleted successfully."},"confirmTitle":"Are you sure you want to delete this coupon?","confirmText":"If you press yes, it will be permenantly deleted and it won't be possible to retrieve it.","confirmCancel":"Cancel","confirmButton":"Delete"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ManageCoupon/locales/en.json
// module id = 1699
// module chunks = 0